import { apiFetch } from './client'

export interface SyncDeviceStat {
  device_id: string
  device_name: string
  device_status: string
  pending: number
  processing: number
  done: number
  failed: number
  needs_attention: number
}

export interface SyncJob {
  id: string
  device_id: string
  device_name: string
  operation: string
  status: 'pending' | 'processing' | 'done' | 'failed' | 'needs_attention'
  attempts: number
  last_error?: string
  payload: Record<string, unknown>
  created_at: string
  processed_at?: string
  next_retry_at?: string
  member_id?: string
  member_name?: string
}

// Supabase backup state of a local-first install. `mode: 'remote'` means
// Supabase is the live database, so there is no backup to report.
export type BackupStatus =
  | { mode: 'remote' }
  | {
      mode: 'local'
      pending: number
      needs_attention: number
      replicating: boolean
      degraded: boolean
      last_synced_at: string | null
    }

export const getBackupStatus = () =>
  apiFetch<BackupStatus>('/sync/backup-status')

export const getSyncStats = () =>
  apiFetch<{ stats: SyncDeviceStat[] }>('/sync/stats')

export const getSyncJobs = (params?: { deviceId?: string; status?: string; limit?: number; offset?: number }) => {
  const qs = new URLSearchParams()
  if (params?.deviceId)          qs.set('deviceId', params.deviceId)
  if (params?.status)            qs.set('status',   params.status)
  if (params?.limit  != null)    qs.set('limit',    String(params.limit))
  if (params?.offset != null)    qs.set('offset',   String(params.offset))
  return apiFetch<{ jobs: SyncJob[]; total: number; limit: number; offset: number }>(
    `/sync/jobs${qs.toString() ? '?' + qs : ''}`,
  )
}

export const triggerSync = () =>
  apiFetch<{ ok: boolean }>('/sync/trigger', { method: 'POST' })

export const retrySync = (params?: { deviceId?: string; jobId?: string }) =>
  apiFetch<{ ok: boolean }>('/sync/retry', {
    method: 'POST',
    body: JSON.stringify(params ?? {}),
  })

export const clearDoneJobs = () =>
  apiFetch<{ ok: boolean; deleted: number }>('/sync/jobs/done', { method: 'DELETE' })

export const clearSupersededJobs = () =>
  apiFetch<{ ok: boolean; deleted: number }>('/sync/jobs/superseded', { method: 'DELETE' })
